import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext(null);

const COLLECTION_NAMES = ["services", "samples", "ugc_models", "proofs", "testimonials", "faqs"];

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [collections, setCollections] = useState({
    services: [], samples: [], ugc_models: [], proofs: [], testimonials: [], faqs: [],
  });

  const load = useCallback(async () => {
    try {
      const s = await api.get("/settings");
      setSettings(s.data);
    } catch (e) {
      setSettings({});
    }
    try {
      const results = await Promise.all(
        COLLECTION_NAMES.map((n) => api.get(`/content/${n}`).catch(() => ({ data: [] })))
      );
      const next = {};
      COLLECTION_NAMES.forEach((n, i) => (next[n] = results[i].data || []));
      setCollections(next);
    } catch (e) {}
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <SiteContext.Provider value={{ settings, reload: load, ...collections }}>
      {children}
    </SiteContext.Provider>
  );
}

export function useSite() {
  return useContext(SiteContext);
}
